import { render, staticRenderFns } from "./APSaleHistoryForReturn.vue?vue&type=template&id=0117f72b&"
import script from "./APSaleHistoryForReturn.vue?vue&type=script&lang=js&"
export * from "./APSaleHistoryForReturn.vue?vue&type=script&lang=js&"
import style0 from "./APSaleHistoryForReturn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "APSaleHistoryForReturn.vue"
export default component.exports